import { put, call, takeLatest, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import publicationsAPI from '../../api/publications';
import { Creators as GlobalCreators } from '../../reducers/global';
import { Creators, Types } from '../../reducers/landingpage';
import getState from '../../utils/getState';

function extractData(data) {
  const seo = data.find((item) => item.position === 'hotsiteconfig') || {};

  const content = data.filter((item) => item.position !== 'hotsiteconfig');

  return {
    seo,
    content,
  };
}

function* landingpageRequest({ query }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(publicationsAPI.hotsite, query, siteId);

    if (isEmpty(data)) throw 'Conteúdo não encontrado';

    const extractedData = extractData(data);

    yield put(Creators.landingpageSuccess(extractedData));
  } catch (error) {
    yield put(GlobalCreators.errorApp(formatError(error)));
    yield put(Creators.landingpageFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.LANDINGPAGE_REQUEST, landingpageRequest);
}
